import styled from 'styled-components';
import { Main } from 'globalStyles/Containers';

export const Container = styled(Main)`
  padding-top: 16px;
  padding-bottom: 48px;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  flex-grow: 1;
`;

export const ImageContainer = styled.div`
  align-self: center;
  width: 240px;
  height: 240px;
  margin-bottom: 16px;
  background-image: url(/assets/backgrounds/notFound.svg);
`;

export const BackButtonContainer = styled.div`
  margin-top: auto;
  align-self: flex-start;
  align-items: center;
  cursor: pointer;
  display: flex;
`;

export const MarkdownContainer = styled.div`
  margin-bottom: 56px;
`;

export const BackButtonText = styled.p`
  color: ${({ theme }) => theme.primaryColor};
  margin-left: 2px;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 1px;
  text-transform: uppercase;
`;

export const Title = styled.h2`
  font-style: normal;
  font-weight: 600;
  line-height: 32px;
  color: ${({ theme }) => theme.primaryColor};
  margin-bottom: 8px;
`;
